'use strict';
import angular from 'angular';
import SettingsController from './settings.controller';
import SettingsService from './settings.service';
import WellevateCallout from '../../../components/wellevate-callout';
import AccountActionsMenu from '../../../components/account-actions-menu';
import QuickOrder from '../../../components/quick-order';
import GeneralInfoEditForm from '../../../components/forms/account/general-info-edit';
import ProfessionalInfoForm from '../../../components/forms/account/professional-info';
import CredentialList from '../../../components/credential-list';
import RXCredentialList from '../../../components/rx-credential-list';
import CreditCardList from '../../../components/credit-card-list';
import CreditCardListFrame from '../../../components/credit-card-list-frame';
import ShippingAddressList from '../../../components/shipping-address-list';
import DropShipShippingAddressList from '../../../components/drop-ship-shipping-address-list';
import BrandAgreements from '../../../components/brand-agreements';
import EmailPreferences from '../../../components/email-preferences';
import OrderList from '../../../components/order-list';
import { SettingsEvents } from './settings-events';
export default angular.module('eeComUiApp.settings', [GeneralInfoEditForm, ProfessionalInfoForm,
    CredentialList, RXCredentialList, ShippingAddressList, DropShipShippingAddressList, BrandAgreements,
    EmailPreferences, OrderList, AccountActionsMenu, QuickOrder, CreditCardList, CreditCardListFrame, WellevateCallout])
    .service('SettingsService', SettingsService)
    .service('SettingsEvents', SettingsEvents)
    .component('settings', {
    template: require('./settings.html'),
    controller: SettingsController,
    controllerAs: 'st'
})
    .name;
//# sourceMappingURL=index.js.map